export const contractHolder = {
  emulator: null,
  testnet: "0xa16ab1d0abde3625",
  mainnet: "0x097bafa4e0b48eef"
}
